export default __webpack_public_path__ + "222efe756f731804aa27e557e8f1096e.png";